import { GET_LIBRARY_GOAL_BY_ID_SUCCESS, GET_LIBRARY_GOALS_SUCCESS, GET_LIBRARY_FOLDERS_SUCCESS } from './library.types';

const initialState = {
    goalList: [],
    goalById: null,
    libraryFolders: [],
};

export const libraryReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Goals */
        case GET_LIBRARY_GOALS_SUCCESS:
            return {
                ...state,
                goalList: action.payload,
            };

        case GET_LIBRARY_GOAL_BY_ID_SUCCESS:
            return {
                ...state,
                goalById: action.payload,
            };

        /** End */

        /** Clinical Library Folders */
        case GET_LIBRARY_FOLDERS_SUCCESS:
            return {
                ...state,
                libraryFolders: action.payload,
            };
        /** End */

        default:
            return state;
    }
};
